export default "__VITE_ASSET__B2LunDPU__"